<form fsForm [submit]="save">
  <fs-dialog>
    <h1 mat-dialog-title>Donate to organization</h1>
    <mat-dialog-content>
      <div class="fs-column content">
        <fs-autocomplete-chips
          [fetch]="fetchOrganizations"
          [fetchOnFocus]="true"
          [(ngModel)]="organization"
          label="Select Organization"
          [multiple]="false"
          [required]="true"
          chipImage="image.small"
          name="organization">
          <ng-template fsAutocompleteChipsTemplate let-data="object">
            {{ data.name }}
          </ng-template>
        </fs-autocomplete-chips>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button color="primary" type="submit">Donate</button>
      <button
          type="button"
          mat-button
          mat-dialog-close>
        Cancel
      </button>
    </mat-dialog-actions>
  </fs-dialog>
</form>
